<p-toast></p-toast>

<div class="profile-page">
  <div class="page-header">
    <app-back-button
      [title]="'Личный кабинет' | translate"
      parentRoute="/main-menu"
    ></app-back-button>
    <div class="page-subtitle">
      <p>{{ 'Управление профилем и настройками' | translate }}</p>
    </div>
  </div>

  <div class="profile-content" *ngIf="!loading">
    <div class="profile-grid">
      <!-- User Information Card -->
      <div class="profile-card user-info-card">
        <div class="card-header">
          <div class="header-icon">
            <i class="pi pi-user"></i>
          </div>
          <h2>{{ 'User Information' | translate }}</h2>
        </div>
        <div class="card-content">
          <div class="info-row">
            <span class="info-label">{{ 'User name' | translate }}:</span>
            <span class="info-value">{{ userProfile?.userName || '—' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'Email' | translate }}:</span>
            <span class="info-value">{{ userProfile?.email || '—' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'Name' | translate }}:</span>
            <span class="info-value">{{ userProfile?.firstName || '—' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'Last name' | translate }}:</span>
            <span class="info-value">{{ userProfile?.lastName || '—' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'Roles' | translate }}:</span>
            <span class="info-value roles-value">
              <span *ngFor="let role of userProfile?.roles; let last = last" class="role-badge">
                {{ getRoleDisplayName(role) }}<span *ngIf="!last">, </span>
              </span>
            </span>
          </div>
        </div>
      </div>

      <!-- Actions Card -->
      <div class="profile-card actions-card">
        <div class="card-header">
          <div class="header-icon">
            <i class="pi pi-cog"></i>
          </div>
          <h2>{{ 'Actions' | translate }}</h2>
        </div>
        <div class="card-content">
          <button 
            pButton 
            type="button" 
            [label]="'Сменить пароль' | translate" 
            icon="pi pi-lock"
            class="action-button"
            (click)="openChangePasswordModal()">
          </button>
        </div>
      </div>

      <!-- Active Support Tickets Card -->
      <div class="profile-card tickets-card">
        <div class="card-header">
          <div class="header-icon">
            <i class="pi pi-ticket"></i>
          </div>
          <h2>{{ 'Active Support Tickets' | translate }}</h2>
        </div>
        <div class="card-content">
          <div *ngIf="ticketsLoading" class="loading-state">
            <i class="pi pi-spin pi-spinner"></i>
            <span>{{ 'Загрузка...' | translate }}</span>
          </div>
          
          <div *ngIf="!ticketsLoading && activeTickets.length === 0" class="empty-state">
            <i class="pi pi-inbox"></i>
            <p>{{ 'No active support tickets' | translate }}</p>
          </div>

          <div *ngIf="!ticketsLoading && activeTickets.length > 0" class="tickets-list">
            <div 
              *ngFor="let ticket of activeTickets"
              class="ticket-item"
              (click)="goToTicket(ticket)">
              <div class="ticket-header">
                <div class="ticket-number">{{ 'Request' | translate }} #{{ ticket.number }}</div>
                <p-tag 
                  [value]="getStatusLabel(ticket.ticketStatus)"
                  [severity]="getStatusSeverity(ticket.ticketStatus)">
                </p-tag>
              </div>
              <div class="ticket-body">
                <div class="ticket-info-row">
                  <span class="label">{{ 'Date Created' | translate }}:</span>
                  <span class="value">{{ ticket.createAt | date:'dd.MM.yyyy HH:mm' }}</span>
                </div>
                <div class="ticket-info-row">
                  <span class="label">{{ 'Module' | translate }}:</span>
                  <span class="value">{{ ticket.moduleName }}</span>
                </div>
              </div>
            </div>
          </div>

          <button 
            *ngIf="!ticketsLoading"
            pButton 
            type="button" 
            [label]="'All Tickets' | translate" 
            icon="pi pi-list"
            class="view-all-button p-button-text"
            (click)="goToAllTickets()">
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="loading-container">
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
  </div>
</div>

<!-- Change Password Modal -->
<p-dialog 
  [(visible)]="showChangePasswordModal"
  [header]="'Смена пароля' | translate"
  [modal]="true"
  [style]="{width: '500px'}"
  [dismissableMask]="true"
  styleClass="change-password-dialog">
  
  <div class="password-form">
    <div class="form-group">
      <label>{{ 'Старый пароль' | translate }}</label>
      <div class="password-input-wrapper">
        <input 
          [type]="showOldPassword ? 'text' : 'password'"
          [(ngModel)]="changePasswordForm.oldPassword"
          placeholder="{{ 'Введите старый пароль' | translate }}"
          class="password-input"
        />
        <button 
          pButton 
          type="button" 
          class="p-button-text password-toggle"
          (click)="showOldPassword = !showOldPassword">
          <i [class]="showOldPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
        </button>
      </div>
    </div>

    <div class="form-group">
      <label>{{ 'Новый пароль' | translate }}</label>
      <div class="password-input-wrapper">
        <input 
          [type]="showNewPassword ? 'text' : 'password'"
          [(ngModel)]="changePasswordForm.newPassword"
          placeholder="{{ 'Введите новый пароль' | translate }}"
          class="password-input"
        />
        <button 
          pButton 
          type="button" 
          class="p-button-text password-toggle"
          (click)="showNewPassword = !showNewPassword">
          <i [class]="showNewPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
        </button>
      </div>
    </div>

    <div class="form-group">
      <label>{{ 'Повторите новый пароль' | translate }}</label>
      <div class="password-input-wrapper">
        <input 
          [type]="showConfirmPassword ? 'text' : 'password'"
          [(ngModel)]="changePasswordForm.confirmPassword"
          placeholder="{{ 'Повторите новый пароль' | translate }}"
          class="password-input"
        />
        <button 
          pButton 
          type="button" 
          class="p-button-text password-toggle"
          (click)="showConfirmPassword = !showConfirmPassword">
          <i [class]="showConfirmPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
        </button>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button 
      pButton 
      type="button" 
      [label]="'Отмена' | translate"
      class="p-button-text"
      (click)="closeChangePasswordModal()"
      [disabled]="isChangingPassword">
    </button>
    <button 
      pButton 
      type="button" 
      [label]="'Сменить пароль' | translate"
      class="p-button-primary"
      icon="{{isChangingPassword ? 'pi pi-spinner pi-spin' : ''}}"
      (click)="changePassword()"
      [disabled]="isChangingPassword">
    </button>
  </ng-template>
</p-dialog>

